// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_ComprovanteRevisarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /subscriptions/setup-fee/comprovante-revisar — o Full aprova ou recusa (com motivo). */
import { registerContract } from './validate'

export interface SetupFee_ComprovanteRevisarInput {
comprovante_id?: number
acao?: string
motivo?: string
}

registerContract('SetupFee_ComprovanteRevisarInput', {
  comprovante_id: { type: 'number',  required: false },
  acao:           { type: 'string',  required: false },
  motivo:         { type: 'string',  required: false },
})
